<template>
  <div class="search-bar">
    <img src="../assets/img/search.png" alt="">
    <input type="text" placeholder="輸入電影名進行搜索" v-model.trim="keyword" @keypress.enter="search" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: this.$route.query.keyword || ''
    }
  },
  methods: {
    search() {
      if (!this.keyword) return;

      this.$router.push({ name: 'Search', query: { keyword: this.keyword } })
    }
  }
}
</script>

<style lang="less" scoped>
.search-bar {
  display: flex;
  align-items: center;
  height: 60px;
  background: rgba(241, 240, 239, 1);
  border-radius: 40px;
  border: 1px solid rgb(204,204,204);
  padding: 0 24px;

  img {
    width: 24px;
    height: 24px;
  }

  input {
    margin-left: 30px;
    border: none;
    font-size: 16px;
    outline: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-appearance: none;
    background-color: transparent;
    padding: 10px 0;
    width: 100%;
  }
}
</style>